import React from 'react';
import styles from './ProblemSolution.module.css';

const ProblemSolution = () => {
  return (
    <section className={styles.problemSolution}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          <span className="gold-text">Устали от ошибок и выгорания?</span>
        </h2>
        <div className={styles.content}>
          <div className={styles.problems}>
            <h3 className={styles.subheading}>Проблемы</h3>
            <ul className={styles.list}>
              <li>Перегрузка и выгорание</li>
              <li>Страх неправильных решений</li>
              <li>Финансовая нестабильность</li>
              <li>Отсутствие системы планирования</li>
              <li>Эмоциональные перепады</li>
            </ul>
          </div>
          <div className={styles.solutions}>
            <h3 className={styles.subheading}>Решение через прогноз</h3>
            <ul className={styles.list}>
              <li>Знание энергосберегающих месяцев</li>
              <li>Конкретные даты для важных действий</li>
              <li>Финансовые инструменты (денежные часы, грабитель богатства)</li>
              <li>Персональный календарь на год</li>
              <li>Понимание эмоциональных циклов</li>
            </ul>
          </div>
        </div>
        <div className={styles.imageWrapper}>
          <img 
            src="https://strategy.annavision.me/wp-content/uploads/2025/12/8e30ecf4f6b7472572acd4823c553bc2_1766902126-1.png" 
            alt="Трансформация от хаоса к порядку в 2026 году" 
            className={styles.solutionImage}
          />
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;

